import createClient from "openapi-fetch";
import { serviceURL } from "../../utils/service-url";

import type { paths } from "../../__definitions__/autopilot.changeengine.com-definitions";

export const autopilot = createClient<paths>({
  baseUrl: serviceURL("autopilot"),
  headers: {
    "Content-Type": "application/json",
  },
});
